<template>
    <div class="w-100 mt-2 mx-2 p-2 border border-primary">
        <div class="form-group row">
            <label :for="'field-name' + '-' + this.uuid" class="col-sm-2 col-form-label">Field</label>
            <div class="col-sm-4">
                <input type="text" v-model="field.name" class="form-control" :id="'field-name' + '-' + this.uuid">
            </div>
            <div class="col-sm-6 d-flex">
                <button @click.prevent="remove" type="button" tabindex="-1"
                    class="btn btn-default ml-auto">Cancel</button>
            </div>
        </div>
        <div class="form-group row">
            <label :for="'field-type' + '-' + this.uuid" class="col-sm-2 col-form-label">Type</label>
            <div class="col-sm-4">
                <select2 :id="'field-type' + '-' + this.uuid" v-model="field.type" @change="typeChange"
                    class="form-control w-100" placeholder="choose a type">
                    <option value="text">text</option>
                    <option value="radio">radio</option>
                    <option value="checkbox">checkbox</option>
                </select2>
            </div>
            <div class="col-sm-4 offset-sm-2">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" :id="'field-required' + '-' + this.uuid"
                        v-model="field.required">
                    <label class="form-check-label" :for="'field-required' + '-' + this.uuid">
                        Required
                    </label>
                </div>
            </div>
        </div>
        <div class="form-group row" v-if="field.type === 'checkbox'">
            <label :for="'field-count' + '-' + this.uuid" class="col-sm-2 col-form-label">Cout</label>
            <div class="col-sm-4">
                <input type="number" min="1" class="form-control" :id="'field-count' + '-' + this.uuid"
                    v-model="field.count">
            </div>
        </div>
        <div class="form-group row" v-if="field.type === 'checkbox' || field.type === 'radio'">
            <label :for="'field-values' + '-' + this.uuid" class="col-sm-2 col-form-label">Values</label>
            <div class="col-sm-10">
                <select2 v-model="field.values" :id="'field-values' + '-' + this.uuid" class="tags form-control w-100"
                    multiple>
                </select2>
            </div>
        </div>
    </div>
</template>
<script>
    import jQuery from 'jquery';

    import uuid from '../../library/uuid';
    import select2Tools from '../../library/select2-tools';

    export default {
        props: {
            value: { default: {} }
        },
        data() {
            return {
                uuid: uuid(),
                field: this.newField
            };
        },
        watch: {
            value: {
                deep: true,
                handler(newValue, oldValue) {
                    Object.keys(newValue).forEach(key => {
                        this.field[key] = newValue[key];
                    });
                }
            },
            field: {
                deep: true,
                handler(newValue, oldValue) {
                    this.$emit('input', newValue);
                    this.$emit('change', newValue);
                }
            }
        },
        mounted() {
            this.$nextTick(this.renderView);
            this.field = this.loadField(this.value);
        },
        updated() {
            this.$nextTick(this.renderView);
        },
        methods: {
            valuesChange(e) {
                this.field.values = jQuery(e.target).val();
            },
            synchronizeData(newValue, oldValue) {
                return Object.assign({}, oldValue, newValue);
            },
            typeChange() {
                if (this.field.type === 'text') this.field.values = [];
                if (this.field.type !== 'checkbox') this.field.count = null;
            },
            newField() {
                return {
                    name: null,
                    type: null,
                    required: null,
                    count: null,
                    values: []
                };
            },
            loadField(data) {
                let new_field = this.newField();
                Object.keys(new_field).forEach(key => new_field[key] = data[key]);
                return new_field;
            },
            remove() {
                this.$emit('remove');
            }
        }
    };
</script>